import { Link } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';

export default function BackLink(props) {
    return (
        <Link className="tb-form__back-btn button button--secondary button--icon"
            to={props.route}>
            <svg className="icon button__arrow-left" width="14" height="12" focusable="false">
                <use xlinkHref="#icon-arrow-left"></use>
            </svg>
            <span>{props.children}</span>
        </Link>
    );
}

BackLink.propTypes = {
    children: PropTypes.string,
    route: PropTypes.string.isRequired
};
